import * as actionType from "./actionTypes";
import apiClient from "../../services/apiClient";
import { toast } from "react-toastify";
import { showErrorToast, showSuccessToast } from "../../utils/errorHandler";

export const reportProblemStart = () => {
  return {
    type: actionType.REPORT_START
  };
};

export const reportProblemSuccess = details => {
  return {
    type: actionType.REPORT_SUCCESS,
    details
  };
};

export const reportProblemFail = () => {
  return {
    type: actionType.REPORT_FAIL
  };
};

export const reportProblem = (title, desc, func) => {
  return async dispatch => {
    dispatch(reportProblemStart());

    try {
      // Use JWT-based API client for help/support endpoint
      await apiClient.post('/help/email', {
        title,
        message: desc
      });

      dispatch(reportProblemSuccess());
      
      if (func) {
        func();
      }
      
      showSuccessToast('Report sent!');
    } catch (error) {
      console.error('Report problem error:', error);
      dispatch(reportProblemFail());
      
      if (func) {
        func();
      }
      
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          'Failed to send report';
      showErrorToast({ message: errorMessage });
    }
  };
};
